<template>
	<div>
		<div class="container">
			<nav aria-label="breadcrumb">
				<ol class="breadcrumb">
					<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
						<a href="#">首頁</a>
					</router-link>
					<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
						<a href="#">其他資訊</a>
					</router-link>
					<li class="breadcrumb-item">
						裝備設計圖需求減少列表
					</li>
				</ol>
			</nav>
			<div class="item-box">
				<h3 class="item-title">
					裝備設計圖需求減少列表
				</h3>
				<p>2022 日版裝備製作設計圖需求數量減少，下為減少過後的裝備列表以及設計圖數量減少前後差異</p>
				<div class="d-flex flex-wrap justify-content-center">
					<div class="itemBox col-4 col-lg-1 col-md-2 p-2 anm-grow text-center" v-for="item in equipmentCraftList">
						<router-link :to="{ name: 'EquipmentDetail', params: { id: item.equipment_name }}">
							<img class="img-fluid" :src="'/static/images/equipment/icon_equipment_'+ item.equipment_id +'.png'" :alt="item.equipment_name" :title="item.equipment_name">
							<span style="font-size: 1rem">{{item.consume_num_old}} > {{item.consume_num}}</span>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ReduceEq from '../../assets/edata/equipment_craft_reduce.json'
export default {
	name: 'EquipmentReduce',
	metaInfo: {
		title: '裝備設計圖需求減少列表',
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: "超異域公主連結☆Re:Dive 的技能消費瑪那表" }
		]
	},
	data() {
		return {
			equipmentCraftList: ReduceEq,
		}
	},
	created: function() {
		var self = this;
		var craftList = _.forEach(self.equipmentCraftList, function(o) {
			var newObj = _.find(self.$store.getters.getEquipmentCraft, ["equipment_id", o.equipment_id]);
			o["equipment_name"] = self.getEqName(newObj.equipment_id);
			o["consume_num"] = newObj.consume_num_1;
		});
		self.equipmentCraftList = craftList;
	},
	computed: {

	},
	methods: {
		getEqName: function(eq_id) {
			var self = this;
			var eq = _.find(self.$store.getters.getEquipmentCraft, function(o) {
				return o.condition_equipment_id_1 == eq_id;
			});
			if (eq) {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq.equipment_id;
				});
				return eqData.equipment_name;
			} else {
				var eqData = _.find(self.$store.getters.getEquipmentData, function(o) {
					return o.equipment_id == eq_id;
				});
				return eqData.equipment_name;
			}
		},
	},
	mounted: function() {


	}
}

</script>
<style scoped>
</style>
